import { getElementFromEvent, scrollPageTo } from '../utils';

export default class ScrollToLinks {
	constructor() {
		document.addEventListener('click', (e) => {
			const link = getElementFromEvent(e, '[data-scroll-to-link]');

			if (!link) {
				return;
			}

			if (!link.hash) {
				return;
			}

			const offset = link.hasAttribute('data-offset') ? (window.innerHeight / 2 - 100) * -1 : 0;

			scrollPageTo(document.querySelector(`${link.hash}`), 600, offset);
			e.preventDefault();
		});
	}
}
